import { combineReducers } from "@reduxjs/toolkit";
import providerRootReducer from "../Providers/rootReducer/rootReducer";
import clientRootReducer from "../Clients/rootReducer/rootReducer";
import userListingReducer from "../User/components/user-listing/slice/userListingSlice";

const rootReducer = combineReducers({
  ...providerRootReducer,
  ...clientRootReducer,
  userListing: userListingReducer,
});

export default rootReducer;
